"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPage = createPage;
exports.deletePage = deletePage;
exports.discardChanges = discardChanges;
exports.getPageHTML = getPageHTML;
exports.getPageMarkdown = getPageMarkdown;
exports.renamePage = renamePage;
exports.savePage = savePage;
exports.updatePageContentStatus = updatePageContentStatus;
exports.updatePageEditorState = updatePageEditorState;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reactRedux = require("react-redux");
var _exchangeApiClient = require("@mulesoft/exchange-api-client");
var _analytics = require("../../utils/analytics");
var assetsSelectors = _interopRequireWildcard(require("../assets/selectors"));
var portalsActions = _interopRequireWildcard(require("../portals/actions"));
var sessionSelectors = _interopRequireWildcard(require("../session/selectors"));
var actions = _interopRequireWildcard(require("./actionTypes"));
var events = _interopRequireWildcard(require("./events"));
var pagesSelectors = _interopRequireWildcard(require("./selectors"));
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function pageDraftChanged(pagePath) {
  return {
    type: actions.PAGE_PATH_CHANGED,
    pagePath: pagePath
  };
}
function fetchPageHTMLSuccess(_ref) {
  var contentType = _ref.contentType,
    groupId = _ref.groupId,
    assetId = _ref.assetId,
    version = _ref.version,
    pagePath = _ref.pagePath,
    data = _ref.data,
    isDraft = _ref.isDraft;
  return {
    type: actions.FETCH_PAGE_HTML_SUCCESS,
    contentType: contentType,
    data: data,
    groupId: groupId,
    assetId: assetId,
    isDraft: isDraft,
    version: version,
    pagePath: pagePath
  };
}
function fetchPageMarkdownSuccess(_ref2) {
  var contentType = _ref2.contentType,
    groupId = _ref2.groupId,
    assetId = _ref2.assetId,
    version = _ref2.version,
    pagePath = _ref2.pagePath,
    data = _ref2.data,
    isDraft = _ref2.isDraft;
  return {
    type: actions.FETCH_PAGE_MD_SUCCESS,
    contentType: contentType,
    data: data,
    groupId: groupId,
    assetId: assetId,
    isDraft: isDraft,
    version: version,
    pagePath: pagePath
  };
}
function createPageRequest(_ref3) {
  var groupId = _ref3.groupId,
    assetId = _ref3.assetId,
    version = _ref3.version,
    pagePath = _ref3.pagePath,
    pageName = _ref3.pageName;
  return {
    type: actions.CREATE_PAGE.REQUEST,
    groupId: groupId,
    assetId: assetId,
    version: version,
    pageName: pageName,
    pagePath: pagePath,
    isDraft: true
  };
}
function createPageSuccess(_ref4) {
  var groupId = _ref4.groupId,
    assetId = _ref4.assetId,
    version = _ref4.version,
    pageName = _ref4.pageName,
    pagePath = _ref4.pagePath,
    initialPath = _ref4.initialPath;
  return _objectSpread({
    type: actions.CREATE_PAGE.SUCCESS,
    groupId: groupId,
    assetId: assetId,
    version: version,
    pageName: pageName,
    pagePath: pagePath,
    initialPath: initialPath,
    isDraft: true
  }, (0, _analytics.clientTrackPayload)({
    eventSchema: events.PAGE_CREATED,
    properties: {
      pagePath: pagePath,
      pageName: pageName
    }
  }));
}
function createPageFailure(_ref5) {
  var groupId = _ref5.groupId,
    assetId = _ref5.assetId,
    version = _ref5.version,
    pagePath = _ref5.pagePath;
  return {
    type: actions.CREATE_PAGE.FAILURE,
    groupId: groupId,
    assetId: assetId,
    version: version,
    pagePath: pagePath,
    isDraft: true
  };
}
function renamePageRequest(_ref6) {
  var groupId = _ref6.groupId,
    assetId = _ref6.assetId,
    version = _ref6.version,
    pagePath = _ref6.pagePath,
    pageName = _ref6.pageName,
    oldPage = _ref6.oldPage,
    oldPagePath = _ref6.oldPagePath;
  return {
    type: actions.RENAME_PAGE.REQUEST,
    groupId: groupId,
    assetId: assetId,
    version: version,
    pagePath: pagePath,
    pageName: pageName,
    oldPagePath: oldPagePath,
    oldPage: oldPage,
    isDraft: true
  };
}
function renamePageFailure(_ref7) {
  var groupId = _ref7.groupId,
    assetId = _ref7.assetId,
    version = _ref7.version,
    pagePath = _ref7.pagePath,
    oldPage = _ref7.oldPage,
    oldPagePath = _ref7.oldPagePath;
  return {
    type: actions.RENAME_PAGE.FAILURE,
    groupId: groupId,
    assetId: assetId,
    version: version,
    pagePath: pagePath,
    oldPagePath: oldPagePath,
    oldPage: oldPage,
    isDraft: true
  };
}
function renamePageSuccess(_ref8) {
  var groupId = _ref8.groupId,
    assetId = _ref8.assetId,
    version = _ref8.version,
    pagePath = _ref8.pagePath,
    pageName = _ref8.pageName,
    oldPage = _ref8.oldPage,
    oldPagePath = _ref8.oldPagePath;
  return _objectSpread({
    type: actions.RENAME_PAGE.SUCCESS,
    groupId: groupId,
    assetId: assetId,
    version: version,
    pagePath: pagePath,
    pageName: pageName,
    oldPagePath: oldPagePath,
    oldPage: oldPage,
    isDraft: true
  }, (0, _analytics.clientTrackPayload)({
    eventSchema: events.PAGE_RENAMED,
    properties: {
      pagePath: pagePath,
      oldPagePath: oldPagePath
    }
  }));
}
function deletePageRequest(_ref9) {
  var groupId = _ref9.groupId,
    assetId = _ref9.assetId,
    version = _ref9.version,
    pagePath = _ref9.pagePath;
  return {
    type: actions.DELETE_PAGE.REQUEST,
    groupId: groupId,
    assetId: assetId,
    version: version,
    pagePath: pagePath,
    isDraft: true
  };
}
function deletePageFailure(_ref10) {
  var groupId = _ref10.groupId,
    assetId = _ref10.assetId,
    version = _ref10.version,
    pagePath = _ref10.pagePath,
    page = _ref10.page;
  return {
    type: actions.DELETE_PAGE.FAILURE,
    groupId: groupId,
    assetId: assetId,
    version: version,
    pagePath: pagePath,
    page: page,
    isDraft: true
  };
}
function deletePageSuccess(pagePath) {
  return _objectSpread({
    type: actions.DELETE_PAGE.SUCCESS
  }, (0, _analytics.clientTrackPayload)({
    eventSchema: events.PAGE_DELETED,
    properties: {
      pagePath: pagePath
    }
  }));
}
function savePageRequest(_ref11) {
  var groupId = _ref11.groupId,
    assetId = _ref11.assetId,
    version = _ref11.version,
    pagePath = _ref11.pagePath,
    markdown = _ref11.markdown;
  return {
    type: actions.SAVE_PAGE.REQUEST,
    groupId: groupId,
    assetId: assetId,
    isDraft: true,
    version: version,
    pagePath: pagePath,
    markdown: markdown
  };
}
function savePageSuccess(_ref12) {
  var groupId = _ref12.groupId,
    assetId = _ref12.assetId,
    version = _ref12.version,
    type = _ref12.type,
    pagePath = _ref12.pagePath,
    markdown = _ref12.markdown,
    html = _ref12.html;
  return _objectSpread({
    type: actions.SAVE_PAGE.SUCCESS,
    groupId: groupId,
    assetId: assetId,
    isDraft: true,
    version: version,
    pagePath: pagePath,
    html: html
  }, (0, _analytics.clientTrackPayload)({
    eventSchema: events.PAGE_UPDATED,
    properties: {
      type: type,
      pagePath: pagePath,
      contentLength: markdown.length
    }
  }));
}
function savePageFailure() {
  return {
    type: actions.SAVE_PAGE.FAILURE
  };
}
function updatePageEditorState(pageEditorState) {
  return /*#__PURE__*/function () {
    var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState) {
      var pagePath, pageName, pageContent, groupId, assetId, version, state, page, hasUnsavedChanges;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            pagePath = pageEditorState.pagePath, pageName = pageEditorState.pageName, pageContent = pageEditorState.pageContent, groupId = pageEditorState.groupId, assetId = pageEditorState.assetId, version = pageEditorState.version;
            state = getState();
            page = pagesSelectors.draftOrPublishedPage(state, {
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath
            });
            hasUnsavedChanges = pageName !== page.name || pageContent !== page.markdown;
            _context.next = 6;
            return dispatch({
              type: actions.UPDATE_PAGE_EDITOR_STATE,
              hasUnsavedChanges: hasUnsavedChanges,
              pagePath: pagePath,
              pageName: pageName,
              pageContent: pageContent
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref13.apply(this, arguments);
    };
  }();
}
function updatePageContentStatus(_ref14) {
  var hasUnsavedChanges = _ref14.hasUnsavedChanges;
  return {
    type: actions.UPDATE_UNSAVED_CHANGES,
    hasUnsavedChanges: hasUnsavedChanges
  };
}
function setPageLoadingError(error, params) {
  return {
    type: actions.SET_PAGE_LOADING_ERROR,
    error: error,
    params: params
  };
}
function getPage(_ref15) {
  var getPath = _ref15.getPath,
    pushFn = _ref15.pushFn,
    minorVersion = _ref15.minorVersion,
    groupId = _ref15.groupId,
    assetId = _ref15.assetId,
    version = _ref15.version,
    _ref15$pagePath = _ref15.pagePath,
    pagePath = _ref15$pagePath === void 0 ? _utils.HOME_PATH : _ref15$pagePath,
    contentType = _ref15.contentType,
    _ref15$isDraft = _ref15.isDraft,
    isDraft = _ref15$isDraft === void 0 ? false : _ref15$isDraft,
    _ref15$domain = _ref15.domain,
    domain = _ref15$domain === void 0 ? null : _ref15$domain,
    _ref15$forwardedHost = _ref15.forwardedHost,
    forwardedHost = _ref15$forwardedHost === void 0 ? null : _ref15$forwardedHost,
    _ref15$forwardedPath = _ref15.forwardedPath,
    forwardedPath = _ref15$forwardedPath === void 0 ? null : _ref15$forwardedPath;
  var strategies = {
    html: {
      selector: pagesSelectors.pageHTML,
      serviceMethod: function serviceMethod(service) {
        return service.getHTML;
      },
      onSuccess: fetchPageHTMLSuccess
    },
    markdown: {
      selector: pagesSelectors.pageMarkdown,
      serviceMethod: function serviceMethod(service) {
        return service.getMarkdown;
      },
      onSuccess: fetchPageMarkdownSuccess
    }
  };
  var strategy = strategies[contentType];
  return /*#__PURE__*/function () {
    var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch, getState, _ref16) {
      var config, state, asset, pageService, contentFromState, context, response, isTermsPage;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            config = _ref16.config;
            state = getState();
            asset = assetsSelectors.asset(state, {
              groupId: groupId,
              assetId: assetId,
              version: version
            });
            pageService = new _exchangeApiClient.PageService(config);
            if (!version) {
              // eslint-disable-next-line no-param-reassign, prefer-destructuring
              version = asset.version;
            }
            contentFromState = strategy.selector(state, {
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath,
              isDraft: isDraft,
              domain: domain,
              forwardedHost: forwardedHost,
              forwardedPath: forwardedPath
            });
            context = sessionSelectors.context(state);
            if (isDraft) {
              dispatch(pageDraftChanged(pagePath));
            }
            dispatch(portalsActions.pageLoading());
            if (!(contentFromState !== undefined && contentFromState !== null)) {
              _context2.next = 12;
              break;
            }
            dispatch(portalsActions.pageLoaded());
            return _context2.abrupt("return", contentFromState);
          case 12:
            _context2.prev = 12;
            _context2.next = 15;
            return strategy.serviceMethod(pageService)({
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath,
              context: context,
              isDraft: isDraft,
              domain: domain,
              forwardedHost: forwardedHost,
              forwardedPath: forwardedPath
            });
          case 15:
            response = _context2.sent;
            if (response.redirectPagePath) {
              pushFn(getPath('page', {
                groupId: groupId,
                assetId: assetId,
                minorVersion: minorVersion,
                version: version,
                pagePath: response.redirectPagePath,
                isDraft: isDraft
              }), 301);
            } else {
              dispatch(strategy.onSuccess({
                data: response.text,
                contentType: response.contentType,
                groupId: groupId,
                assetId: assetId,
                isDraft: isDraft,
                version: version,
                pagePath: pagePath
              }));
              dispatch(portalsActions.pageLoaded());
            }
            return _context2.abrupt("return", response);
          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](12);
            isTermsPage = pagePath === _utils.TERMS_PAGE;
            if (!(_context2.t0.status === 404 && isTermsPage)) {
              _context2.next = 25;
              break;
            }
            return _context2.abrupt("return", dispatch(portalsActions.pageLoaded()));
          case 25:
            dispatch(setPageLoadingError(_context2.t0, {
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath,
              isDraft: isDraft,
              contentType: contentType
            }));
            throw _context2.t0;
          case 27:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[12, 20]]);
    }));
    return function (_x3, _x4, _x5) {
      return _ref17.apply(this, arguments);
    };
  }();
}

/** Gets the HTML for a documentation page of an asset portal */
function getPageHTML(assetParams) {
  return getPage(_objectSpread(_objectSpread({}, assetParams), {}, {
    contentType: 'html'
  }));
}

/** Gets the Markdown for a documentation page of an asset portal */
function getPageMarkdown(assetParams) {
  return getPage(_objectSpread(_objectSpread({}, assetParams), {}, {
    contentType: 'markdown'
  }));
}

/** Saves the markdown content for a documentation page */
function savePage(_ref18) {
  var groupId = _ref18.groupId,
    assetId = _ref18.assetId,
    version = _ref18.version,
    type = _ref18.type,
    minorVersion = _ref18.minorVersion,
    versionGroup = _ref18.versionGroup,
    pagePath = _ref18.pagePath,
    markdown = _ref18.markdown,
    pushFn = _ref18.pushFn,
    getPath = _ref18.getPath;
  return /*#__PURE__*/function () {
    var _ref20 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch, getState, _ref19) {
      var config, state, context, pageService;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            config = _ref19.config;
            state = getState();
            context = sessionSelectors.context(state);
            dispatch(savePageRequest({
              groupId: groupId,
              assetId: assetId,
              version: version,
              markdown: markdown,
              pagePath: pagePath
            }));
            _context3.prev = 4;
            pageService = new _exchangeApiClient.PageService(config);
            _context3.next = 8;
            return pageService.upsert({
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath,
              markdown: markdown,
              context: context
            });
          case 8:
            dispatch(updatePageContentStatus({
              hasUnsavedChanges: false
            }));
            pushFn(getPath('pageDraft', {
              type: type,
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion,
              versionGroup: versionGroup,
              pagePath: pagePath
            }));
            return _context3.abrupt("return", dispatch(savePageSuccess({
              groupId: groupId,
              assetId: assetId,
              version: version,
              type: type,
              pagePath: pagePath,
              markdown: markdown,
              html: (0, _utils.markdownToHTML)({
                config: config,
                markdown: markdown,
                groupId: groupId,
                assetId: assetId,
                version: version,
                isDraft: true,
                options: {
                  highlight: _utils.highlightSyntax,
                  minHeaderLevel: 2,
                  escapeNotebooks: true
                }
              })
            })));
          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](4);
            dispatch(savePageFailure());
            throw _context3.t0;
          case 17:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[4, 13]]);
    }));
    return function (_x6, _x7, _x8) {
      return _ref20.apply(this, arguments);
    };
  }();
}

/** Discards the current changes of a documentation page */
function discardChanges(_ref21) {
  var hasUnpublishedChanges = _ref21.hasUnpublishedChanges,
    params = _ref21.params,
    pushFn = _ref21.pushFn,
    getPath = _ref21.getPath;
  return function (dispatch, getState) {
    var state = getState();
    var publishedPage = pagesSelectors.page(state, _objectSpread(_objectSpread({}, params), {}, {
      isDraft: false
    }));
    var pageParams = params;
    if (!hasUnpublishedChanges && !publishedPage) {
      pageParams = _objectSpread(_objectSpread({}, params), {}, {
        pagePath: _utils.HOME_PATH
      });
    }
    var discardURL = getPath(hasUnpublishedChanges ? 'pageDraft' : 'page', pageParams);
    dispatch(updatePageContentStatus({
      hasUnsavedChanges: false
    }));
    pushFn(discardURL);
  };
}

/** Creates a documentation page from the asset portal a new documentation page in an asset portal */
function createPage(_ref22) {
  var groupId = _ref22.groupId,
    assetId = _ref22.assetId,
    version = _ref22.version,
    minorVersion = _ref22.minorVersion,
    versionGroup = _ref22.versionGroup,
    pageName = _ref22.pageName,
    getPath = _ref22.getPath,
    pushFn = _ref22.pushFn;
  return /*#__PURE__*/function () {
    var _ref24 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch, getState, _ref23) {
      var config, pagePath, state, context, pageRequestForFailure, pageService, pageRequest, response, pageInfo;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            config = _ref23.config;
            pagePath = pageName;
            state = getState();
            context = sessionSelectors.context(state);
            pageRequestForFailure = {
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath
            };
            dispatch(portalsActions.pageLoading());
            _context4.prev = 6;
            pageService = new _exchangeApiClient.PageService(config);
            pageRequest = {
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath,
              pageName: pagePath
            };
            dispatch(createPageRequest(pageRequest));
            _context4.next = 12;
            return pageService.create({
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath,
              context: context
            });
          case 12:
            response = _context4.sent;
            pageInfo = {
              groupId: groupId,
              assetId: assetId,
              version: version,
              pageName: response.name,
              pagePath: response.path,
              initialPath: pagePath
            };
            dispatch(createPageSuccess(pageInfo));
            pushFn(getPath('pageEdit', {
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion,
              versionGroup: versionGroup,
              pageName: response.name,
              pagePath: response.path
            }));
            dispatch(portalsActions.pageLoaded());
            _context4.next = 24;
            break;
          case 19:
            _context4.prev = 19;
            _context4.t0 = _context4["catch"](6);
            dispatch(portalsActions.pageLoaded());
            dispatch(createPageFailure(pageRequestForFailure));
            throw _context4.t0;
          case 24:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[6, 19]]);
    }));
    return function (_x9, _x10, _x11) {
      return _ref24.apply(this, arguments);
    };
  }();
}

/** Deletes a documentation page from the asset portal */
function deletePage(_ref25) {
  var groupId = _ref25.groupId,
    assetId = _ref25.assetId,
    version = _ref25.version,
    minorVersion = _ref25.minorVersion,
    versionGroup = _ref25.versionGroup,
    pagePath = _ref25.pagePath,
    pushFn = _ref25.pushFn,
    getPath = _ref25.getPath;
  return /*#__PURE__*/function () {
    var _ref27 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch, getState, _ref26) {
      var config, state, context, page, pageRequest, pageService;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            config = _ref26.config;
            state = getState();
            context = sessionSelectors.context(state);
            page = pagesSelectors.page(state, {
              groupId: groupId,
              assetId: assetId,
              version: version,
              isDraft: true,
              pagePath: pagePath
            });
            pageRequest = {
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath
            };
            dispatch(deletePageRequest(pageRequest));
            _context5.prev = 6;
            pageService = new _exchangeApiClient.PageService(config);
            _context5.next = 10;
            return pageService.remove({
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath,
              context: context
            });
          case 10:
            pushFn(getPath('pageEdit', {
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion,
              versionGroup: versionGroup,
              pagePath: _utils.HOME_PATH
            }));
            dispatch(deletePageSuccess(pagePath));
            _context5.next = 18;
            break;
          case 14:
            _context5.prev = 14;
            _context5.t0 = _context5["catch"](6);
            dispatch(deletePageFailure(_objectSpread(_objectSpread({}, pageRequest), {}, {
              page: page
            })));
            throw _context5.t0;
          case 18:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[6, 14]]);
    }));
    return function (_x12, _x13, _x14) {
      return _ref27.apply(this, arguments);
    };
  }();
}

/** Renames a documentation page */
function renamePage(_ref28) {
  var groupId = _ref28.groupId,
    assetId = _ref28.assetId,
    version = _ref28.version,
    minorVersion = _ref28.minorVersion,
    versionGroup = _ref28.versionGroup,
    pagePath = _ref28.pagePath,
    pageName = _ref28.pageName,
    oldPagePath = _ref28.oldPagePath,
    pushFn = _ref28.pushFn,
    getPath = _ref28.getPath;
  return /*#__PURE__*/function () {
    var _ref30 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch, getState, _ref29) {
      var config, state, context, oldPage, pageRequest, pageService, response, renamedPageRequest, renamePromise;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            config = _ref29.config;
            state = getState();
            context = sessionSelectors.context(state);
            oldPage = pagesSelectors.page(state, {
              groupId: groupId,
              assetId: assetId,
              version: version,
              isDraft: true,
              pagePath: oldPagePath
            });
            pageRequest = {
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath,
              pageName: pageName,
              oldPagePath: oldPagePath,
              oldPage: oldPage
            };
            dispatch(renamePageRequest(pageRequest));
            _context6.prev = 6;
            pageService = new _exchangeApiClient.PageService(config);
            _context6.next = 10;
            return pageService.rename({
              groupId: groupId,
              assetId: assetId,
              version: version,
              pagePath: pagePath,
              oldPagePath: oldPagePath,
              context: context
            });
          case 10:
            response = _context6.sent;
            renamedPageRequest = _objectSpread(_objectSpread({}, pageRequest), {}, {
              pageName: response.name,
              pagePath: response.path
            });
            (0, _reactRedux.batch)(function () {
              dispatch(updatePageContentStatus({
                hasUnsavedChanges: false
              }));
              dispatch(renamePageSuccess(renamedPageRequest));
            });
            pushFn(getPath('pageEdit', {
              groupId: groupId,
              assetId: assetId,
              version: version,
              minorVersion: minorVersion,
              versionGroup: versionGroup,
              pagePath: response.path
            }));
            renamePromise = new Promise(function (resolve) {
              process.nextTick(function () {
                resolve({
                  pageName: renamedPageRequest.pageName,
                  pagePath: renamedPageRequest.pagePath
                });
              });
            }); // eslint-disable-next-line @typescript-eslint/return-await
            return _context6.abrupt("return", renamePromise);
          case 18:
            _context6.prev = 18;
            _context6.t0 = _context6["catch"](6);
            dispatch(renamePageFailure(pageRequest));
            throw _context6.t0;
          case 22:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[6, 18]]);
    }));
    return function (_x15, _x16, _x17) {
      return _ref30.apply(this, arguments);
    };
  }();
}
//# sourceMappingURL=actions.js.map